import { observable, action, runInAction } from 'mobx';
import customerManagementAPI from '../apis/customerManagementAPI'
import alertMessage from '../utils/alertMessage'

export default class customerManagementStore {
  constructor(rootStore) {
      this.rootStore = rootStore;
  }
  @observable isFetching = false;

  @observable customerValue=null
  @action
  onChangeCustomer(value){
    if(value?.customer===null){
      this.customerValue = {...value,customer:{
          parentCustomerContactsList:null,
          noteIdentitiesList: null
        }}
    }else {
      this.customerValue =value
    }
  }
  /*edit permission*/
  @action
  async onEditCustomerAction(params,id){
    this.isFetching = true
    try {
      const response = await customerManagementAPI.editAction(params,id)
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 200) {
          alertMessage.success('Edit Success！')
        }else {
          alertMessage.error('Edit Failed！' + response.data.messageEn +'')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*delete permission*/
  @action
  async onDeleteCustomerAction(id) {
    this.isFetching = true
    try {
      const response = await customerManagementAPI.deleteAction(id);
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 200) {
          alertMessage.success('Delete Success！')
        }else {
          alertMessage.error('Delete Failed！' + response.data.messageEn +'')
        }
      });
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
}
